<div class="sh-panel sh-wrap-text">
    <dl *ngIf="thesaurusSuggestion" class="sh-description-list">
        <dt class="sh-description-list__term">{{ 'thesaurus.thesaurus-suggestion-form.suggestion' | translate }}</dt>
        <dd class="sh-description-list__details">{{ thesaurusSuggestionLabel || '-' }}</dd>
        <div class="sh-description-list__inline-group">
            <dt class="sh-description-list__term">{{ 'thesaurus.thesaurus-suggestion-form.submitted-on' | translate }}</dt>
            <dd class="sh-description-list__details">{{ this.thesaurusSuggestion.getArchiveDate() | date : 'dd MMM yyyy'}}</dd>
        </div>
        <div class="sh-description-list__inline-group">
            <dt class="sh-description-list__term">{{ 'thesaurus.thesaurus-suggestion-form.submitted-by' | translate }}</dt>
            <dd class="sh-description-list__details">{{ thesaurusSuggestionSubmitter || '-' }}</dd>
        </div>
        <dt class="sh-description-list__term">{{ 'thesaurus.thesaurus-suggestion-form.added-to-scheme' | translate }}</dt>
        <dd class="sh-description-list__details">{{ thesaurusSuggestionScheme || '-' }}</dd>
    </dl>

    <h4 class="sh-accentuate-title">{{"thesaurus.thesaurus-concept-dialog.translations" | translate}}</h4>
    <dl class="sh-description-list">
        <ng-container *ngIf="thesaurusPreferredLabels.length === 0">
            <dd class="sh-description-list__details">
                {{"thesaurus.thesaurus-concept-dialog.no-translations" | translate : { term: thesaurusSuggestionLabel} }}
            </dd>
        </ng-container>
        <ng-container *ngFor="let label of thesaurusPreferredLabels">
            <dt class="sh-description-list__term">{{ 'languages.' + label.Lang.toLowerCase() | translate }}</dt>
            <dd class="sh-description-list__details">{{ label.Label }}</dd>
        </ng-container>
    </dl>

    <h4 class="sh-accentuate-title">{{"thesaurus.thesaurus-concept-dialog.alternative-terms" | translate}}</h4>
    <dl class="sh-description-list">
        <ng-container *ngIf="thesaurusAltLabels.length === 0">
            <dd class="sh-description-list__details">{{"thesaurus.thesaurus-concept-dialog.no-alternatives" | translate}}</dd>
        </ng-container>
        <ng-container *ngFor="let LabelList of thesaurusAltLabels">
            <dt class="sh-description-list__term">{{ 'languages.' + LabelList[0].toLowerCase() | translate }}</dt>
            <dd class="sh-description-list__details">
                <ul class="sh-tag-list sh-clear-margin-top">
                    <div class="sh-tag--link sh-tag-list__item" style="pointer-events: None" *ngFor="let label of LabelList[1]">
                        <span class="sh-tag__label">{{label}}</span>
                    </div>
                </ul>
            </dd>
        </ng-container>
    </dl>
</div>
